import { defineStyleConfig } from '@chakra-ui/react';

export const IconButton = defineStyleConfig({
	baseStyle: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		lineHeight: 0,
		svg: {
			display: 'block',
		},
	},
});
